<div id="cashierAppHolder" class="make-deposit">
    @if (
        !dataService.error() &&
        !optionListService.dataLoading() &&
        !depositService.dataLoading() &&
        !userDataService.dataLoading() &&
        depositAvailable
    ) {
        @if (depositService.showODpopUp()) {
            <app-od-popup />
        } @else {
            <app-deposit />
        }
    }
</div>
<div id="card-container" class="d-none"></div>
